import { render, staticRenderFns } from "./PSDRenderLayer.vue?vue&type=template&id=2a0149e8"
import script from "./PSDRenderLayer.vue?vue&type=script&lang=js"
export * from "./PSDRenderLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports